/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/No"
  
}) {
let imageCardImageDefinitionSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'image_card',
path: 'image_definition.slot_key',
format: fromFormat.getPatientImageName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 data="image_card.image_definition.slot_key"
 format="/Data/format.js getPatientImageName"
 text={imageCardImageDefinitionSlotKeyValueData}
/>
{children}
</React.Fragment>)
}